import Particles from "particlesjs";

document.addEventListener("DOMContentLoaded", () => {
  Particles.init({
    selector: ".hero-background",
    color: "#DA0464",
    connectParticles: true,
  });
});
